import {
    ExclamationTriangleIcon,
    InformationCircleIcon,
} from "@heroicons/react/24/outline";
import { CheckIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useNotification } from "../../providers/NotificationProvider.tsx";

export enum NotificationStatus {
    success,
    info,
    failure,
}

const notificationContainer = document.getElementById(
    "notification-root"
) as HTMLElement;

const Notification = () => {
    const notificationRef = useRef<HTMLDivElement>(null);
    const { notificationData, setIsNotificationVisible, isNotificationVisible } =
        useNotification();
    const notificationNode = document.createElement("div");
    useEffect(() => {
        notificationContainer.appendChild(notificationNode);
        return () => {
            notificationContainer.removeChild(notificationNode);
        };
    }, [notificationNode]);
    useEffect(() => {
        if (isNotificationVisible) {
            setTimeout(() => {
                if (notificationRef.current)
                    notificationRef.current.setAttribute("close", "");
                setTimeout(() => {
                    setIsNotificationVisible(false);
                }, 150);
            }, 5000);
        }
    }, [isNotificationVisible]);
    const notificationWrapper = (
        <div
            ref={notificationRef}
            onAnimationEnd={() => {
                notificationRef.current?.removeAttribute("close");
            }}
            data-open={isNotificationVisible ? isNotificationVisible : undefined}
            className={`notification z-50 fixed top-10 left-1/2 -translate-x-1/2 rounded-xl text-white p-4 flex items-center space-x-3 shadow w-11/12 md:w-96 
        ${notificationData.status === NotificationStatus.info
                    ? "bg-blue-500/90 shadow-blue-500"
                    : ""
                }
        ${notificationData.status === NotificationStatus.success
                    ? "bg-green-500/90 shadow-green-500"
                    : ""
                }
        ${notificationData.status === NotificationStatus.failure
                    ? "bg-red-500/90 shadow-red-500"
                    : ""
                }
    `}
        >
            {notificationData.status === NotificationStatus.info ?
                <InformationCircleIcon className="w-10 h-10 shrink-0" />
                :
                ""
            }
            {notificationData.status === NotificationStatus.success ?
                <CheckIcon className="w-10 h-10 shrink-0" />
                :
                ""
            }
            {notificationData.status === NotificationStatus.failure ?
                <ExclamationTriangleIcon className="h-10 w-10 shrink-0" />
                :
                ""
            }
            <div className="">
                <p className="font-bold ">{notificationData.title}</p>
                <p className="">{notificationData.description}</p>
            </div>
        </div>
    );
    return createPortal(notificationWrapper, notificationNode);
};

export default Notification;
